import React from "react";
import styled from "styled-components";
import { Colors } from "../../ColorConstants";
import ProductCounter from "./ProductCounter";
import { Text } from "../../TextConstants";
import { Delete } from "../../assets/icons";

const ProductDetailsMobile = ({
  data,
  onDelete,
  onSubtract,
  onAdd,
  onContinueShopping,
  isAqua,
  hasSpinPromo,
}) => {

  const getTime = (timeString) => {
    const startTimeStr = timeString.slice(0, 4);
    const endTimeStr = timeString.slice(5);

    let startHour = parseInt(startTimeStr.slice(0, 2));
    let endHour = parseInt(endTimeStr.slice(0, 2));
    const startMinute = parseInt(startTimeStr.slice(2));
    const endMinute = parseInt(endTimeStr.slice(2));

    let startSuffix = "AM";
    if (startHour >= 12) {
      startSuffix = "PM";
      if (startHour > 12) {
        startHour -= 12;
      }
    }

    let endSuffix = "AM";
    if (endHour >= 12) {
      endSuffix = "PM";
      if (endHour > 12) {
        endHour -= 12;
      }
    }

    const formattedStartTime = `${startHour
      .toString()
      .padStart(2, "0")}:${startMinute
      .toString()
      .padStart(2, "0")} ${startSuffix}`;
    const formattedEndTime = `${endHour.toString().padStart(2, "0")}:${endMinute
      .toString()
      .padStart(2, "0")} ${endSuffix}`;
    return `${formattedStartTime} - ${formattedEndTime}`;
  };

  return (
    <ProductDetailContainer>
      {data?.map((item) => (
        <ProductDetailSubContainer>
          <TitleContainer>
            <ProductTitle>{item?.name}</ProductTitle>
            {isAqua && (
              <DeleteImage src={Delete} onClick={() => onDelete(item?._id)} />
            )}
          </TitleContainer>
          {isAqua &&
            item.slots.map((slot, index) => (
              <SubProducts>
                {`Unit ${Number(index + 1)} - ${slot.aquaDuration} min`}(
                {getTime(slot.slot)}) - QAR {slot.unitPrice}
              </SubProducts>
            ))}
          {!isAqua && (
            <BottomContainer>
              <PriceText>{item?.totalPrice} QAR</PriceText>
              <CounterContainer>
                <ProductCounter
                  onSubtract={() => onSubtract(item._id)}
                  onAdd={() => onAdd(item._id)}
                  count={item.qty}
                />
              </CounterContainer>
            </BottomContainer>
          )}
        </ProductDetailSubContainer>
      ))}
      <LineDiv />
      {!hasSpinPromo && (
        <AddItemsContainer>
          <AddItemsButton onClick={onContinueShopping}>
            <ButtonTitle>{Text.addMoreItems}</ButtonTitle>
          </AddItemsButton>
        </AddItemsContainer>
      )}
    </ProductDetailContainer>
  );
};

export default ProductDetailsMobile;

const ProductDetailContainer = styled.div`
  @media only screen and (min-width: 576px) {
    display: none;
  }
  display: flex;
  flex-direction: column;
  padding: 0rem 1rem;
  box-sizing: border-box;
  //   border: 1px solid red;
  justify-content: center;
  align-items: center;
  gap: 0.5rem;
`;

const ProductDetailSubContainer = styled.div`
  display: flex;
  flex-direction: column;
  background-color: ${Colors.aqua};
  width: 90%;
  padding: 1rem;
  gap: 0.8rem;
  border-radius: 5px;
`;
const TitleContainer = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
`;

const ProductTitle = styled.span`
  color: ${Colors.white};
  font-size: 0.9rem;
  font-weight: 500;
  width: 70%;
`;

const SubProducts = styled.span`
  color: ${Colors.white};
  font-size: 12px;
  font-weight: 300;
`;
const BottomContainer = styled.div`
  display: flex;
  flex-direction: row;
  align-items: flex-end;
  justify-content: space-between;
`;
const PriceText = styled.span`
  color: ${Colors.white};
  // text-align: right;
  font-size: 0.8rem;
  font-weight: 300;
`;
const CounterContainer = styled.div`
  display: flex;
  width: 25%;
  @media only screen and (max-width: 414px) {
    width: 30%;
  }
`;
const LineDiv = styled.div`
  width: 95%;
  border: 0.3px solid ${Colors.secondaryBlack};
  opacity: 0.2;
  margin-top: 1rem;
`;

const AddItemsContainer = styled.div`
  display: flex;
  justify-content: center;
  width: 95%;
  margin-top: 1rem;
`;

const AddItemsButton = styled.button`
  background: ${Colors.white};
  outline: none;
  display: flex;
  width: 100%;
  padding: 1rem;
  justify-content: center;
  align-items: center;
  border-radius: 8px;
  border: 1px solid ${Colors.aqua};
  cursor: pointer;
`;
const ButtonTitle = styled.span`
  font-size: 1rem;
  font-weight: 500;
  text-align: center;
  color: ${Colors.aqua};
`;

const DeleteImage = styled.img`
  width: 1rem;
  height: 1.2rem;
  cursor: pointer;
`;
